import React from 'react';
import {ResponsiveContainer} from '@emburse/ui-core';
import {BaseConfigurationContext} from 'shared/context/BaseConfigurationContext';

export interface ViewContainerProps {
    children?: React.ReactNode;
}

const viewContainerSx = (isInsideEmbark: boolean, offSetHeight: number) => [
    !isInsideEmbark && {paddingTop: '61px'},
    {paddingBottom: '24px', minHeight: `calc(100% - ${offSetHeight}px)`},
];

export const ViewContainer = ({children, ...props}: ViewContainerProps) => {
    const {isInsideEmbark} = React.useContext(BaseConfigurationContext);
    const offSetHeight = isInsideEmbark ? 37 : 100;
    return (
        <ResponsiveContainer
            align='left'
            size='fullWidth'
            sx={viewContainerSx(isInsideEmbark, offSetHeight)} {...props}>
            {children}
        </ResponsiveContainer>
    );
};